export default {
      id: "obd__coolant_temperature-usage",
      viewBox: "0 0 20 29",
      url: __webpack_public_path__ + "img/icons.svg#obd__coolant_temperature",
      toString: function () {
        return this.url;
      }
    }